import { PageWrapper } from '@repo/ui';
import { useAuth } from 'presentation/app/hooks/useAuth';
import { useEffect, useState } from 'react';
import {
  Row,
  Col,
  Nav,
  Card,
  NavItem,
  NavLink,
  TabPane,
  TabContent,
} from 'reactstrap';

import { ContainerInfoProfile } from '../components/containerInfoProfile';
import { AccountDetails } from '../components/tabNavigate/accountDetails';
import { Security } from '../components/tabNavigate/security';
import { userProfile } from '../hooks/userProfile';

interface Tab {
  id: string;
  label: string;
  tabContent: JSX.Element;
}

export const Profile = () => {
  // state tabs
  const [activeTab, setActiveTab] = useState('1');
  const { currentUser } = useAuth();

  // hooks
  const {
    handleToggleModal,
    clearModalAndClose,
    requestUpdateProfile,
    requestGetByIdProfile,
    requestChangePasswordProfile,
    profileList,
    isModalOpen,
    loadingUpdateProfile,
    loadingModalChangePassword,
    validationModalChangePassword,
  } = userProfile();

  // tabs navigate
  const tabs: Tab[] = [
    {
      id: '1',
      label: 'Dados da conta',
      tabContent: (
        <AccountDetails
          profileList={profileList}
          requestUpdateProfile={requestUpdateProfile}
          loadingUpdateProfile={loadingUpdateProfile}
        />
      ),
    },
    {
      id: '2',
      label: 'Segurança',
      tabContent: (
        <Security
          isModalOpen={isModalOpen}
          handleToggleModal={handleToggleModal}
          clearModalAndClose={clearModalAndClose}
          loadingModalChangePassword={loadingModalChangePassword}
          requestChangePasswordProfile={requestChangePasswordProfile}
          validationModalChangePassword={validationModalChangePassword}
        />
      ),
    },
  ];

  // effect
  useEffect(() => {
    requestGetByIdProfile({ id: currentUser.id });
  }, []);

  return (
    <PageWrapper title="Perfil">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h4 className="fw-bold">Perfil</h4>
          <p className="text-muted mb-0">
            Aqui você pode visualizar e atualizar suas informações pessoais.
          </p>
        </div>
      </div>
      <Row>
        <Col md={3}>
          <ContainerInfoProfile />
        </Col>
        <Col md={9} xs={12} xxl={9} sm={12}>
          <Card
            style={{
              minHeight: '300px',
            }}
          >
            <Nav tabs className="d-flex">
              {tabs.map((tab, idx) => (
                <NavItem key={idx} className="">
                  <NavLink
                    className={`p-3 ${activeTab === tab.id ? 'active' : ''}`}
                    style={{
                      cursor: 'pointer',
                      borderBottom: `${activeTab === tab.id ? '2px solid #1b6654' : ''}`,
                    }}
                    onClick={() => setActiveTab(tab.id)}
                  >
                    <div className="d-flex justify-content-center align-items-center gap-1">
                      {tab.label}
                    </div>
                  </NavLink>
                </NavItem>
              ))}
            </Nav>
            <TabContent activeTab={activeTab}>
              {tabs.map((tab, idx) => (
                <TabPane key={idx} tabId={tab.id}>
                  {activeTab === tab.id && tab.tabContent}
                </TabPane>
              ))}
            </TabContent>
          </Card>
        </Col>
      </Row>
    </PageWrapper>
  );
};
